<template>
  <div class="status-filter-wrapper">
    <h4 class="mb-3 h5">Filter By Status</h4>
    <ul class="list-unstyled fs-sm">
      <li v-for="option in filterOptions">
        <a class="nav-link fw-normal d-flex align-items-center px-0 py-1"
           :class="{'active': isSelected(option)}"
           href="#" @click.prevent="selectOption(option)">
          <i :class="getIconClass(option)"></i>
          <span>{{ option.label }}</span>
<!--          <span class="text-muted ms-auto">(3)</span>-->
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "StatusFilter",
  props: ['filters'],
  data() {
    return {
      filterKey: 'status',
      filterOptions: [
        {
          value: null,
          label: 'Show All',
          icon: 'fi-users'
        },
        {
          value: 'admin-users',
          label: 'Admin Users',
          icon: 'fi-security'
        },
        {
          value: 'active-users',
          label: 'Active Users',
          icon: 'fi-check'
        },
        {
          value: 'invited',
          label: 'Invited',
          icon: 'fi-mail'
        }
      ]
    }
  },
  methods: {
    isSelected(option) {
      return this.filters[this.filterKey] == option.value;
    },
    selectOption(option) {
      this.filters[this.filterKey] = option.value;
    },
    getIconClass(option) {
      return option.icon + ' opacity-70 me-2';
    }
  }
}
</script>

<style scoped>
.status-filter-wrapper {
  max-width: 15rem;
}
</style>